<template>
  <div class="text-center">
    <v-progress-circular :size="spinnerSize" color="primary" indeterminate />
  </div>
</template>

<script>
export default {
  name: 'AppSpinner',

  props: {
    spinnerSize: {
      type: Number,
      default: 50,
    },
  },
}
</script>
